import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { Code404Component } from './code404/code404.component';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { UploadComponent } from './upload/upload.component';
import { FilesComponent } from './files/files.component';
import { CognitoService } from './service/cognito.service';
import { S3Service } from './service/s3.service';
import { WebsiteComponent } from './website/website.component';

@NgModule({
  declarations: [
    AppComponent,
    Code404Component,
    LoginComponent,
    SignupComponent,
    UploadComponent,
    FilesComponent,
    WebsiteComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    CognitoService,
    S3Service
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
